import React from "react";

/**
 * Utility to summarize insurance commissions for a job and insurance type.
 * Returns a two-column row with the insurance label and the total commission
 * for that employer, or "No" when the product was not sold at that employer.
 *
 */
const INSURANCE_KEYS = {
  life: { label: 'Individual Life Insurance', first: 'indlifirstyear', renew: 'indlirenewcom', flag: 'solicitindlife' },
  annuity: { label: 'Individual Annuity', first: 'indannfirstyear', renew: 'indannrenewcom', flag: 'solicitindannuity' },
  disability: { label: 'Individual Disability Income', first: 'inddisincfirstyear', renew: 'inddisincrenewcom', flag: 'solicitinddisability' },
  ltc: { label: 'Individual Long Term Care Insurance', first: 'indlongtermfirstyear', renew: 'indlongtermrenewcom', flag: 'solicitindltc' },
};

export function getInsuranceCommissionSummary(job, psrRecords, type) {
  // Destructure insurance keys for the given type
  const { label, first, renew, flag } = INSURANCE_KEYS[type] || {};
  // Only show for sales positions
  if (!label || job?.salesposition !== true) return null;

  // Render a two-column row: label left, value right
  const renderRow = (value) => (
    <div style={{ display: 'flex', marginBottom: 4 }}>
      <span style={{ width: 260 }}>{label}</span>
      <span>{value}</span>
    </div>
  );

  // Product was not sold at this employer
  if (job[flag] !== true) return renderRow("No");

  // Sum first year and renewal commissions of the PSR records belonging to
  // this employment record only (matched by id, never by company name, so
  // employers sharing a name or PSR years stay separate)
  const total = (Array.isArray(psrRecords) ? psrRecords : [])
    .filter((psr) => psr.employmenthistoryid === job.employmenthistoryid)
    .reduce(
      (sum, psr) => sum + Number(psr[first] || 0) + Number(psr[renew] || 0),
      0
    );

  return renderRow(`$${total.toLocaleString()}`);
}
